import { useQuery } from "@apollo/client";
import { GET_SALON_SLUG } from "@/graphql/salon";

/**
 * Hook to fetch salon slug
 * This is used for settings/online features that need the actual salon slug
 */
export function useSalonSlug(salonId?: string) {
  const { data, loading, error, refetch } = useQuery(GET_SALON_SLUG, {
    variables: { salonId: salonId || "" },
    skip: !salonId,
    fetchPolicy: "cache-and-network",
  });

  return {
    slug: data?.getSalon?.slug,
    loading,
    error,
    refetch,
  };
}
